import type { NovelItem } from '@app/_proto/Protos/novels';
import HomeContent from '@app/domains/home/components/HomeContent';

type Props = {
    content: NovelItem | undefined;
    rank: number;
    isLoading?: boolean;
};

export default function HomePopularContent({ content, rank, isLoading }: Props) {
    return (
        <HomeContent content={content} isLoading={isLoading}>
            <HomeContent.Image rank={rank} />
            <HomeContent.TextWrapper>
                <HomeContent.ReviewScore className="font-set-b13 md:font-set-b16" />
                <HomeContent.Title className="font-set-sb13 md:font-set-sb15" />
            </HomeContent.TextWrapper>
        </HomeContent>
    );
}
